import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f0f6f012"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "unit-range-container"
};
const _hoisted_2 = {
    key: 1,
    class: "unit-range-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedH4 = _resolveComponent("FriedH4");
    const _component_FriedNumericalStepper = _resolveComponent("FriedNumericalStepper");
    const _component_DropdownItemsWrapper = _resolveComponent("DropdownItemsWrapper");
    return (_ctx.open)
        ? (_openBlock(), _createBlock(_component_DropdownItemsWrapper, {
            key: 0,
            class: "units-modifier-container"
        }, {
            default: _withCtx(() => [
                _createVNode(_component_FriedH4, { class: "settings-header" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('choose-amount')), 1)
                    ]),
                    _: 1
                }),
                (_ctx.getMinValue(_ctx.inputField))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t('min-amount')), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.getMinValue(_ctx.inputField)), 1)
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.getMaxValue(_ctx.inputField))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t('max-amount')), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.getMaxValue(_ctx.inputField)), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_FriedNumericalStepper, {
                    "model-value": Number(_ctx.inputField.value),
                    class: "input",
                    "data-external": "editor-pricing-table-units-modifier-menu-default-value-input",
                    pattern: "[0-9]*",
                    min: _ctx.getMaxValue(_ctx.inputField) ? Number(_ctx.getMinValue(_ctx.inputField)) : 1,
                    max: _ctx.getMaxValue(_ctx.inputField) ? Number(_ctx.getMaxValue(_ctx.inputField)) : null,
                    disabled: _ctx.disabled,
                    error: _ctx.defaultValueError !== '',
                    "error-message": _ctx.$t(_ctx.defaultValueError),
                    onKeypress: _ctx.isKeyAllowed,
                    onBlur: _ctx.handleDefaultValueBlur,
                    onKeydown: [
                        _withKeys(_ctx.handleEnter, ["enter"]),
                        _withKeys(_ctx.handleEsc, ["esc"]),
                        _withKeys(_withModifiers(_ctx.close, ["exact"]), ["tab"])
                    ],
                    "onUpdate:modelValue": _ctx.handleDefaultValueChange,
                    onPaste: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["prevent"]))
                }, null, 8, ["model-value", "min", "max", "disabled", "error", "error-message", "onKeypress", "onBlur", "onKeydown", "onUpdate:modelValue"])
            ]),
            _: 1
        }))
        : _createCommentVNode("", true);
}
